(function (global) {
  'use strict';

  function stepperMax(serves) { return Math.max(12, serves); }

  function clampPeople(n, serves) { return Math.min(stepperMax(serves), Math.max(1, n)); }

  // amount is recorded for the recipe's own serves, so the quotient is exact in
  // integers; the epsilon only absorbs float noise on a whole-number result.
  function packsNeeded(item, serves, people) {
    return Math.ceil((item.amount * people) / (serves * item.packSize) - 1e-9);
  }

  function isBuyable(item) { return !!item.available && (item.stock == null || item.stock > 0); }

  function lineFor(item, serves, people) {
    var need = packsNeeded(item, serves, people);
    var packs = item.stock == null ? need : Math.min(need, item.stock);
    return { need: need, packs: packs, capped: packs < need, cents: packs * item.cents };
  }

  function totals(data, state) {
    var chosen = [];
    data.mains.forEach(function (m) { if (isBuyable(m)) chosen.push(m); });
    (data.extras || []).forEach(function (x) { if (isBuyable(x) && state.ticked[x.key]) chosen.push(x); });
    var out = { cents: 0, units: 0, lines: [] };
    chosen.forEach(function (item) {
      var l = lineFor(item, data.serves, state.people);
      if (l.packs < 1) return;
      out.lines.push({ item: item, packs: l.packs, cents: l.cents });
      out.cents += l.cents;
      out.units += l.packs;
    });
    return out;
  }

  function perPersonRows(serves) {
    var rows = [2, 4, 6];
    if (rows.indexOf(serves) === -1) rows.push(serves);
    return rows.sort(function (a, b) { return a - b; });
  }

  function perPersonText(item, serves) {
    var v = item.amount / serves;
    var n = Math.round(v);
    var whole = Math.abs(v - n) < 1e-9;
    return (whole ? '' : 'about ') + n + (item.unit === 'g' ? 'g' : '');
  }

  // GA4 truncates event parameter values at 100 characters.
  function itemIds(lines) {
    var out = '';
    for (var i = 0; i < lines.length; i++) {
      var part = lines[i].item.variantId + 'x' + lines[i].packs;
      var next = out ? out + '|' + part : part;
      if (next.length > 100) break;
      out = next;
    }
    return out;
  }

  function addPlan(t) {
    return t.lines.map(function (l) { return { id: l.item.variantId, quantity: l.packs }; });
  }

  function oneTimeQuantities(cart) {
    var out = {};
    ((cart && cart.items) || []).forEach(function (line) {
      if (line.selling_plan_allocation) return;
      out[line.variant_id] = (out[line.variant_id] || 0) + line.quantity;
    });
    return out;
  }

  // The order box only adds one-time lines, so only those can show its effect.
  function diffAdded(before, after, plan) {
    var b = oneTimeQuantities(before);
    var a = oneTimeQuantities(after);
    var added = [];
    var missing = [];
    plan.forEach(function (line) {
      var got = Math.max(0, Math.min(line.quantity, (a[line.id] || 0) - (b[line.id] || 0)));
      if (got > 0) added.push({ id: line.id, quantity: got });
      if (got < line.quantity) missing.push({ id: line.id, quantity: line.quantity - got });
    });
    return { added: added, missing: missing };
  }

  // A line Shopify part-filled (stock fell after page load) is named with the
  // packs that did not go in, so the notice agrees with the drawer.
  function missingLabels(plan, added, missing, namesById) {
    var got = {};
    added.forEach(function (a) { got[a.id] = a.quantity; });
    return missing.map(function (m) {
      var name = namesById[m.id];
      if (!got[m.id]) return name;
      return m.quantity + (m.quantity === 1 ? ' pack of ' : ' packs of ') + name;
    });
  }

  function markerPayload(handle, box, people, lines, cents, partial) {
    return {
      event: 'recipe_box_add',
      recipe_handle: handle,
      box: box,
      people: people,
      line_count: lines.length,
      unit_count: lines.reduce(function (n, l) { return n + l.packs; }, 0),
      value: Math.round(cents) / 100,
      currency: 'SGD',
      item_ids: itemIds(lines),
      partial: !!partial,
    };
  }

  // Selling plan group 78023622960 "Subscribe and Save", as in sham-pdp-atc.js.
  // test_sham_recipe.mjs fails if the maps diverge.
  var PLAN_IDS = {
    '1': '690388500784',
    '2': '690388468016',
    '3': '690388435248',
    '4': '690388402480',
  };

  function registryEntry(o) {
    var plans = { '0': { id: null, price: o.price } };
    if (o.subscribable) {
      Object.keys(PLAN_IDS).forEach(function (k) {
        plans[k] = { id: PLAN_IDS[k], price: o.price };
      });
    }
    return {
      quantity: o.quantity,
      max_quantity: o.maxQuantity,
      tags: o.tags,
      original_price: o.price,
      selling_plans: plans,
    };
  }

  function packMeta(item) {
    if (item.unit === 'piece') return item.packSize === 1 ? '1 piece' : item.packSize + ' pieces a pack';
    return item.packSize >= 1000 ? (item.packSize / 1000) + 'kg pack' : item.packSize + 'g pack';
  }

  // Short-title lines carry size and origin here, as sham-cut-card does.
  function lineMeta(item) {
    var parts = [item.weight || packMeta(item)];
    if (item.origin) parts.push(item.origin);
    if (item.role === 'main' && !/frozen/i.test(item.fullTitle || '')) parts.push('Frozen');
    return parts.join(' · ');
  }

  function extrasLabel(extras, ticked, hasSupermarket) {
    var buyable = (extras || []).filter(isBuyable);
    var parts = [];
    if (buyable.length) {
      var n = buyable.filter(function (x) { return ticked[x.key]; }).length;
      parts.push('Also from us (' + (n ? n + ' of ' + buyable.length + ' ticked' : buyable.length) + ')');
    }
    if (hasSupermarket) parts.push(parts.length ? 'from the supermarket' : 'From the supermarket');
    return parts.join(' and ');
  }

  function railFits(boxHeight, top, viewportHeight) {
    return boxHeight + top + 24 <= viewportHeight;
  }

  function createAddGate() {
    var busy = false;
    return {
      enter: function () { if (busy) return false; busy = true; return true; },
      leave: function () { busy = false; },
      busy: function () { return busy; },
    };
  }

  var api = {
    createAddGate: createAddGate,
    lineMeta: lineMeta,
    extrasLabel: extrasLabel,
    railFits: railFits,
    missingLabels: missingLabels,
    addPlan: addPlan,
    diffAdded: diffAdded,
    markerPayload: markerPayload,
    PLAN_IDS: PLAN_IDS,
    registryEntry: registryEntry,
    stepperMax: stepperMax,
    clampPeople: clampPeople,
    packsNeeded: packsNeeded,
    isBuyable: isBuyable,
    lineFor: lineFor,
    totals: totals,
    perPersonRows: perPersonRows,
    perPersonText: perPersonText,
    itemIds: itemIds,
  };

  if (typeof customElements !== 'undefined' && typeof HTMLElement !== 'undefined') {

    var ICON_PLUS = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 1V11M1 6H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var ICON_MINUS = '<svg width="10" height="2" viewBox="0 0 10 2" fill="none" aria-hidden="true"><path d="M1 1H9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var ICON_ARROW = '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" aria-hidden="true"><path d="M2 12.45L7.75 6.81L2 1.25" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ICON_TICK = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Product titles use " | " separators; binding each pipe to the word before
    // it stops a wrapped line from opening on "|".
    function titleText(s) { return esc(s).replace(/ \| /g, ' | '); }

    function formatMoney(cents) {
      return window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cents, window.Shopify.money_format)
        : '$' + (cents / 100).toFixed(2);
    }

    function people(n) { return n + (n === 1 ? ' person' : ' people'); }

    function packCount(n, item) {
      if (item.unit === 'piece' && item.packSize === 1) return n + (n === 1 ? ' piece' : ' pieces');
      return n + (n === 1 ? ' pack' : ' packs');
    }

    function cartDrawer() { return document.querySelector('cart-drawer[data-cart-drawer]'); }

    function addSelector(box) { return '[data-add][data-box="' + box + '"]'; }

    // Mirrors sham-pdp-atc.js cartSections(): the drawer's line items come from
    // its own section, whose id is only known at runtime.
    function cartSections() {
      var ids = ['cart-items'];
      var drawer = cartDrawer();
      if (drawer && drawer.dataset.sectionId) ids.push(drawer.dataset.sectionId);
      return ids.join(',');
    }

    function syncWindowCart(data) {
      var markup = data.sections && data.sections['cart-items'];
      if (!markup) return;
      var script = new DOMParser().parseFromString(markup, 'text/html').querySelector('#cart-json');
      if (script) window.cart = JSON.parse(script.textContent);
    }

    function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

    async function getCart() {
      var r = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('cart read failed');
      return r.json();
    }

    async function postAdd(items, withSections) {
      var body = { items: items };
      if (withSections) body.sections = cartSections();
      var r = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      var data = null;
      try { data = await r.json(); } catch (e) { data = null; }
      return { ok: r.ok, status: r.status, data: data };
    }

    class ShamRecipe extends HTMLElement {
      connectedCallback() {
        var island = this.querySelector('script[data-recipe-data]');
        if (!island) return;
        this.data = JSON.parse(island.textContent);
        this.state = { people: this.data.serves, ticked: {}, foldOpen: false };
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.flags = {};
        this.gate = createAddGate();
        this.boxes = Array.prototype.slice.call(this.querySelectorAll('[data-recipe-box]'));
        this.bar = this.querySelector('[data-recipe-bar]');
        this.live = this.querySelector('[data-recipe-live]');
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.render();
        this.watchBar();
        this.watchRail();
        var self = this;
        this.onMobileChange = function () { self.render(); };
        if (this.mobile.addEventListener) this.mobile.addEventListener('change', this.onMobileChange);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.railObserver) this.railObserver.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.fitRail) window.removeEventListener('resize', this.fitRail);
        this.showBar(false);
      }

      anyMainBuyable() { return this.data.mains.some(isBuyable); }

      render(focus) {
        var t = totals(this.data, this.state);
        var self = this;
        this.boxes.forEach(function (el) {
          el.innerHTML = self.boxHTML(el.getAttribute('data-recipe-box'), t);
        });
        if (this.bar) this.bar.innerHTML = this.anyMainBuyable() ? this.barHTML(t) : '';
        if (focus) {
          var target = this.querySelector(focus) || this.querySelector('.sham-recipe__box--fallback a');
          if (target) target.focus();
        }
      }

      announce() {
        if (!this.live) return;
        this.live.textContent = 'Cooking for ' + this.state.people + '. Total ' + formatMoney(totals(this.data, this.state).cents) + '.';
      }

      stepperHTML(box) {
        var max = stepperMax(this.data.serves);
        var n = this.state.people;
        var id = 'sham-recipe-for-' + box;
        return '<div class="sham-recipe__for"><span id="' + id + '">Cooking for</span>' +
          '<div class="sham-pdp-atc__qty" role="group" aria-labelledby="' + id + '">' +
          '<button type="button" class="sham-pdp-atc__qty-btn" data-atc-qty-minus data-step="-1" data-box="' + box + '" aria-label="One person fewer"' + (n <= 1 ? ' aria-disabled="true"' : '') + '>' + ICON_MINUS + '</button>' +
          '<span class="sham-pdp-atc__qty-count">' + n + '</span>' +
          '<button type="button" class="sham-pdp-atc__qty-btn" data-atc-qty-plus data-step="1" data-box="' + box + '" aria-label="One person more"' + (n >= max ? ' aria-disabled="true"' : '') + '>' + ICON_PLUS + '</button>' +
          '</div><span>' + (n === 1 ? 'person' : 'people') + '</span></div>';
      }

      lineHTML(item, kind, box) {
        var ok = isBuyable(item);
        var extra = kind === 'also';
        var ticked = !!this.state.ticked[item.key];
        var check = '';
        if (extra) {
          check = '<label class="sham-recipe__check"><input type="checkbox" data-tick="' + esc(item.key) + '" data-box="' + box + '"' +
            (ticked && ok ? ' checked' : '') + (ok ? '' : ' disabled') + ' aria-label="Add ' + esc(item.name) + '">' +
            '<span class="sham-recipe__check-box">' + ICON_TICK + '</span></label>';
        }
        var cls = 'sham-recipe__line' + (extra ? ' sham-recipe__line--extra' : '');
        if (!ok) {
          return '<li class="' + cls + ' is-unavailable">' + check +
            '<span class="sham-recipe__line-thumb sham-recipe__line-thumb--empty" aria-hidden="true"></span>' +
            '<div><div class="sham-recipe__line-name">' + esc(item.name) + '</div>' +
            '<div class="sham-recipe__line-meta">Not available right now</div></div><div></div></li>';
        }
        var l = lineFor(item, this.data.serves, this.state.people);
        var meta = lineMeta(item);
        var thumb = item.image
          ? '<img class="sham-recipe__line-thumb" src="' + esc(item.image) + '" alt="" width="64" height="64" loading="lazy">'
          : '<span class="sham-recipe__line-thumb sham-recipe__line-thumb--empty" aria-hidden="true"></span>';
        return '<li class="' + cls + (extra && ticked ? ' is-ticked' : '') + '">' + check + thumb +
          '<div><a class="sham-recipe__line-title" href="' + esc(item.url) + '">' + titleText(item.title) + '</a>' +
          '<div class="sham-recipe__line-meta">' + esc(meta) + '</div>' +
          (item.note ? '<div class="sham-recipe__line-note">' + esc(item.note) + '</div>' : '') +
          (item.pork ? '<div class="sham-recipe__line-flags"><span class="sham-recipe__chip">' + esc(this.data.strings.pork) + '</span></div>' : '') +
          '</div><div class="sham-recipe__line-right">' +
          '<div class="sham-recipe__line-packs">' + packCount(l.packs, item) + '</div>' +
          '<div class="sham-recipe__line-price">' + formatMoney(l.cents) + '</div>' +
          (l.capped ? '<div class="sham-recipe__line-low">Only ' + item.stock + ' left</div>' : '') +
          '</div></li>';
      }

      addButtonHTML(box, extraClass) {
        var f = this.flags;
        var label = f.adding ? 'Adding…' : (f.added ? 'Added to cart' : 'Add to cart');
        var icon = f.adding ? '<span class="sham-pdp-atc__spinner"></span>' : (f.added ? ICON_TICK : ICON_PLUS);
        return '<button type="button" class="sham-btn sham-btn--primary sham-btn--dark sham-recipe__add ' + (extraClass || '') + '" data-add data-box="' + box + '"' +
          (f.adding ? ' aria-disabled="true"' : '') + '><span>' + label + '</span>' +
          '<span class="sham-btn__circle" aria-hidden="true">' + icon + '</span></button>';
      }

      noticesHTML(box) {
        var f = this.flags;
        if (f.error) {
          return '<div class="sham-recipe__notice sham-recipe__notice--error" role="alert" tabindex="-1" data-notice="' + box + '">' +
            '<strong>We couldn’t add these to your cart.</strong> Nothing was added. Please try again.</div>';
        }
        if (f.partial && f.partial.length) {
          return '<div class="sham-recipe__notice sham-recipe__notice--partial" role="status" data-notice="' + box + '">' +
            esc(this.partialSentence()) + '</div>';
        }
        return '';
      }

      partialSentence() {
        var names = this.flags.partial;
        return 'Not added: ' + names.join(', ') + '. ' + (names.length === 1 ? 'It' : 'They') +
          ' sold out after you opened this page.' + (this.flags.none ? '' : ' Everything else is in your cart.');
      }

      say(message) {
        if (this.live) this.live.textContent = message;
      }

      fallbackHTML(box) {
        var fb = this.data.fallback || {};
        return '<div class="sham-recipe__box sham-recipe__box--fallback' + (box === 'compact' ? ' sham-recipe__box--compact' : '') + '">' +
          '<h2 class="' + (box === 'compact' ? 'sham-recipe__compact-title' : 'sham-recipe__box-title') + '">Order the ingredients</h2>' +
          '<p>The ' + esc(this.data.mainNoun) + ' for this recipe isn’t available right now.</p>' +
          (fb.url ? '<a class="sham-btn sham-btn--primary sham-btn--dark" href="' + esc(fb.url) + '"><span>Shop ' + esc(fb.title) + '</span>' +
            '<span class="sham-btn__circle" aria-hidden="true">' + ICON_ARROW + '</span></a>' : '') +
          this.noticesHTML(box === 'compact' ? 'method' : 'ingredients') + '</div>';
      }

      boxHTML(box, t) {
        if (!this.anyMainBuyable()) return this.fallbackHTML(box);
        var d = this.data;
        var self = this;
        if (box === 'compact') {
          var names = t.lines.map(function (l) { return esc(l.item.name) + ' ×' + l.packs; }).join(' · ');
          var pork = t.lines.some(function (l) { return l.item.pork; })
            ? '<span class="sham-recipe__chip">' + esc(d.strings.pork) + '</span>' : '';
          return '<div class="sham-recipe__box sham-recipe__box--compact"><div class="sham-recipe__compact">' +
            '<div class="sham-recipe__compact-lead"><h2 class="sham-recipe__compact-title">Order the ingredients</h2>' +
            '<p class="sham-recipe__compact-summary">' + names + pork + '</p></div>' +
            this.stepperHTML(box) +
            '<div class="sham-recipe__total-value">' + formatMoney(t.cents) + '</div>' +
            this.addButtonHTML('method') + '</div>' + this.noticesHTML('method') + '</div>';
        }
        var html = '<div class="sham-recipe__box"><div class="sham-recipe__box-head"><h2 class="sham-recipe__box-title">Order the ingredients</h2>' +
          this.stepperHTML(box) + '</div><ul class="sham-recipe__lines">' +
          d.mains.map(function (m) { return self.lineHTML(m, 'main', box); }).join('') + '</ul>';
        var extras = d.extras || [];
        var hasSupermarket = !!(d.supermarket && d.supermarket.length);
        var inner = '';
        if (extras.some(isBuyable)) {
          inner += '<div class="sham-recipe__extras-head">Also from us <span>Tick to add</span></div><ul class="sham-recipe__lines">' +
            extras.filter(isBuyable).map(function (x) { return self.lineHTML(x, 'also', box); }).join('') + '</ul>';
        }
        if (hasSupermarket) {
          inner += '<p class="sham-recipe__supermarket"><strong>From the supermarket:</strong> ' + esc(d.supermarket.join(', ')) + '.</p>';
        }
        if (inner) {
          // Folded on mobile only, to keep the mains and Add to cart together; wider screens show it open.
          var folded = this.mobile.matches && !this.state.foldOpen;
          var foldId = 'sham-recipe-fold-' + box;
          html += '<div class="sham-recipe__fold' + (this.state.foldOpen ? ' is-open' : '') + '">' +
            '<button type="button" class="sham-recipe__fold-toggle" data-fold data-box="' + box + '" aria-expanded="' + !folded + '" aria-controls="' + foldId + '">' +
            '<span>' + esc(extrasLabel(extras, this.state.ticked, hasSupermarket)) + '</span>' +
            '<span class="sham-icon-circle" aria-hidden="true">' + ICON_PLUS + '</span></button>' +
            '<div class="sham-reveal-wrapper' + (folded ? '' : ' is-expanded') + '" id="' + foldId + '"' + (folded ? ' inert' : '') + '>' +
            '<div class="sham-reveal-inner"><div class="sham-reveal-content">' + inner + '</div></div></div></div>';
        }
        html += '<div class="sham-recipe__box-actions"><div class="sham-recipe__total"><span class="sham-recipe__total-label">Total <span>for ' +
          people(this.state.people) + '</span></span><span class="sham-recipe__total-value">' + formatMoney(t.cents) + '</span></div>' +
          this.addButtonHTML('ingredients', 'sham-recipe__box-add') + '</div>' + this.noticesHTML('ingredients');
        if (d.mains.some(function (m) { return isBuyable(m) && m.labelConfirmed; })) {
          html += '<p class="sham-recipe__box-label-line">What’s on the label is everything in the pack.</p>';
        }
        html += '<div class="sham-recipe__box-foot"><span>' + esc(d.strings.delivery) + '</span>' +
          '<a href="' + esc(d.sourceUrl) + '">Know the source</a></div></div>';
        return html;
      }

      barHTML(t) {
        return '<div class="sham-recipe__bar-sum"><span class="sham-recipe__bar-for">For ' + people(this.state.people) + ' · ' +
          t.lines.length + (t.lines.length === 1 ? ' item' : ' items') + '</span>' +
          '<span class="sham-recipe__bar-total">' + formatMoney(t.cents) + '</span></div>' + this.addButtonHTML('bar');
      }

      onClick(e) {
        var copy = e.target.closest('[data-copy-link]');
        if (copy) {
          var status = this.querySelector('[data-copy-status]');
          var done = function (msg) { if (status) status.textContent = msg; };
          if (navigator.clipboard) {
            navigator.clipboard.writeText(copy.getAttribute('data-copy-link')).then(
              function () { done('Link copied.'); },
              function () { done('Could not copy the link.'); });
          }
          return;
        }
        var fold = e.target.closest('[data-fold]');
        if (fold) {
          this.state.foldOpen = !this.state.foldOpen;
          this.render('[data-fold][data-box="' + fold.getAttribute('data-box') + '"]');
          return;
        }
        var step = e.target.closest('[data-step]');
        if (step) {
          if (step.getAttribute('aria-disabled') === 'true') return;
          this.state.people = clampPeople(this.state.people + Number(step.getAttribute('data-step')), this.data.serves);
          this.flags = {};
          this.render('[data-step="' + step.getAttribute('data-step') + '"][data-box="' + step.getAttribute('data-box') + '"]');
          this.announce();
          return;
        }
        var add = e.target.closest('[data-add]');
        if (add && add.getAttribute('aria-disabled') !== 'true') this.onAdd(add.getAttribute('data-box'));
      }

      onChange(e) {
        var tick = e.target.closest('[data-tick]');
        if (!tick) return;
        this.state.ticked[tick.getAttribute('data-tick')] = tick.checked;
        this.flags = {};
        this.render('[data-tick="' + tick.getAttribute('data-tick') + '"][data-box="' + tick.getAttribute('data-box') + '"]');
        this.announce();
      }

      async onAdd(box) {
        if (!this.gate.enter()) return;
        var t = totals(this.data, this.state);
        var plan = addPlan(t);
        if (!plan.length) { this.gate.leave(); return; }
        this.flags = { adding: true };
        this.render(addSelector(box));
        this.say('Adding to cart.');
        clearDrawerNotice();
        var result;
        try {
          result = await this.addAll(plan);
        } catch (err) {
          console.error('sham-recipe: add failed', err);
          result = { added: [], missing: plan, data: null, refused: false };
        }
        this.finish(box, t, result);
        this.gate.leave();
      }

      // One POST for the whole box. If Shopify refuses it (a line sold out after
      // the page loaded), the cart is re-read so nothing is added twice, and the
      // shortfall is retried line by line.
      async addAll(plan) {
        var before = await getCart();
        var first = await postAdd(plan, true);
        if (first.ok) return { added: plan, missing: [], data: first.data, refused: false };
        var after = await getCart();
        var diff = diffAdded(before, after, plan);
        // 422 is Shopify refusing on stock; anything else is a failure to report as such.
        if (first.status !== 422) return Object.assign(diff, { data: null, refused: false });
        for (var i = 0; i < diff.missing.length; i++) {
          await postAdd([diff.missing[i]], false);
        }
        var final = await getCart();
        return Object.assign(diffAdded(before, final, plan), { data: null, refused: true });
      }

      finish(box, t, result) {
        var byVariant = {};
        t.lines.forEach(function (l) { byVariant[l.item.variantId] = l; });
        var addedLines = result.added.map(function (a) {
          var l = byVariant[a.id];
          return { item: l.item, packs: a.quantity, cents: a.quantity * l.item.cents };
        });
        var namesById = {};
        t.lines.forEach(function (l) { namesById[l.item.variantId] = l.item.name; });
        var missingNames = missingLabels(addPlan(t), result.added, result.missing, namesById);
        // Shopify refused these lines, so the stock the page loaded with is stale:
        // stop offering the ones that got nothing, so a retry cannot fail the same way.
        if (result.refused) {
          var gotIds = result.added.map(function (a) { return String(a.id); });
          result.missing.forEach(function (m) {
            if (gotIds.indexOf(String(m.id)) === -1) byVariant[m.id].item.available = false;
          });
        }
        if (!addedLines.length) {
          if (result.refused) {
            this.flags = { partial: missingNames, none: true };
            this.render(addSelector(box));
            this.say(this.partialSentence());
            return;
          }
          this.flags = { error: true };
          this.render();
          var notice = this.querySelector('[data-notice="' + (box === 'method' ? 'method' : 'ingredients') + '"]');
          if (notice) notice.focus();
          this.say('We couldn’t add these to your cart. Nothing was added.');
          return;
        }
        this.register(addedLines);
        if (result.data) {
          try {
            syncWindowCart(result.data);
            var drawer = cartDrawer();
            if (drawer && typeof drawer.updateCartDisplay === 'function') drawer.updateCartDisplay(result.data);
            if (drawer && typeof drawer.setExpanded === 'function') drawer.setExpanded(true);
          } catch (err) {
            console.error('sham-recipe: added to cart, but the drawer refresh failed', err);
          }
        } else {
          window.dispatchEvent(new CustomEvent('cart_changed', { detail: { open: true } }));
        }
        var cents = addedLines.reduce(function (n, l) { return n + l.cents; }, 0);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(markerPayload(this.data.handle, box, this.state.people, addedLines, cents, missingNames.length > 0));
        if (missingNames.length) {
          this.flags = { partial: missingNames };
          this.render(addSelector(box));
          showDrawerNotice(this.partialSentence());
          return;
        }
        this.flags = { added: true };
        this.render(addSelector(box));
        this.say('Added to cart.');
        var self = this;
        setTimeout(function () {
          if (self.flags.added) { self.flags = {}; self.render(self.contains(document.activeElement) ? addSelector(box) : null); }
        }, 2000);
      }

      // The drawer's delivery-plan switch rebuilds lines from bundleStorage, as
      // after a PDP add (sham-pdp-atc.js registerVariant).
      register(lines) {
        if (!window.bundleStorage) return;
        if (!window.bundleStorage.products) window.bundleStorage.products = {};
        lines.forEach(function (l) {
          var existing = window.bundleStorage.products[l.item.variantId];
          window.bundleStorage.products[l.item.variantId] = registryEntry({
            quantity: (existing ? existing.quantity : 0) + l.packs,
            maxQuantity: l.item.stock == null ? 9999 : l.item.stock,
            tags: l.item.tags,
            price: l.item.cents,
            subscribable: l.item.subscribable,
          });
        });
        try {
          window.sessionStorage.setItem('bundleStorage', JSON.stringify(window.bundleStorage));
        } catch (err) {
          console.warn('sham-recipe: could not persist bundleStorage', err);
        }
      }

      // Desktop: the full box sits in a side column and sticks below the live
      // header edge (the header hides on scroll-down, see sham-source-nav.js
      // trackHeader), but only when the whole box fits, so Add to cart never
      // sticks below the fold.
      watchRail() {
        var full = this.querySelector('[data-recipe-box="full"]');
        if (!full) return;
        var self = this;
        var candidates = ['sticky-header', '.header-wrapper', '.shopify-section-group-header-group'];
        var header = function () {
          for (var i = 0; i < candidates.length; i++) {
            var el = document.querySelector(candidates[i]);
            if (!el) continue;
            var rect = el.getBoundingClientRect();
            if (rect.height > 0) return rect;
          }
          return null;
        };
        // Whether to stick is decided against the header's full height, so the
        // answer does not flip as the header hides and returns on scroll.
        this.fitRail = function () {
          var rect = header();
          var fits = self.desktop.matches && railFits(full.offsetHeight, rect ? Math.round(rect.height) : 0, window.innerHeight);
          full.classList.toggle('is-railed', fits);
        };
        var queued = false;
        var place = function () {
          queued = false;
          var rect = header();
          self.style.setProperty('--sham-recipe-rail-top', (rect ? Math.max(0, Math.round(rect.bottom)) : 0) + 'px');
        };
        this.onScroll = function () {
          if (queued || !self.desktop.matches) return;
          queued = true;
          requestAnimationFrame(place);
        };
        place();
        this.fitRail();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.fitRail);
        if ('ResizeObserver' in window) {
          this.railObserver = new ResizeObserver(this.fitRail);
          this.railObserver.observe(full);
        }
      }

      // Mobile only: shown once the reader has scrolled past the full box, hidden
      // while either box is on screen (design, "Sticky mobile bar").
      watchBar() {
        if (!this.bar || !('IntersectionObserver' in window) || !this.anyMainBuyable()) return;
        var self = this;
        var seen = {};
        var passedFirst = false;
        var mobile = window.matchMedia('(max-width: 749px)');
        var update = function () {
          var anyVisible = Object.keys(seen).some(function (k) { return seen[k]; });
          self.showBar(mobile.matches && passedFirst && !anyVisible);
        };
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            seen[en.target.getAttribute('data-recipe-box')] = en.isIntersecting;
            if (en.target === self.boxes[0]) passedFirst = !en.isIntersecting && en.boundingClientRect.top < 0;
          });
          update();
        });
        this.boxes.forEach(function (b) { self.observer.observe(b); });
        if (mobile.addEventListener) mobile.addEventListener('change', update);
      }

      showBar(show) {
        if (!this.bar) return;
        this.bar.classList.toggle('is-visible', show);
        this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) this.bar.removeAttribute('inert');
        else this.bar.setAttribute('inert', '');
        // Same convention as sham-bundle-sticky-bar.js: reserve page space while a
        // bottom bar is up, and clear it so the stylesheet value returns.
        document.body.style.paddingBottom = show ? Math.ceil(this.bar.offsetHeight) + 'px' : '';
      }
    }

    var drawerNoticeObserver = null;

    function clearDrawerNotice() {
      var old = document.querySelector('.sham-recipe-drawer-notice');
      if (old) old.remove();
      if (drawerNoticeObserver) { drawerNoticeObserver.disconnect(); drawerNoticeObserver = null; }
    }

    // The drawer covers the box at mobile widths, so the partial-add sentence is
    // repeated at the top of the drawer. [data-cart-main-content] is outside the
    // blocks g-cart.js re-renders, so the node survives the drawer's refresh.
    function showDrawerNotice(sentence) {
      clearDrawerNotice();
      var drawer = cartDrawer();
      var host = drawer && drawer.querySelector('[data-cart-main-content]');
      if (!host) return;
      var p = document.createElement('p');
      p.className = 'sham-recipe-drawer-notice';
      p.setAttribute('role', 'status');
      p.textContent = sentence;
      host.insertBefore(p, host.firstChild);
      drawerNoticeObserver = new MutationObserver(function () {
        if (drawer.getAttribute('aria-expanded') === 'false') clearDrawerNotice();
      });
      drawerNoticeObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    if (!customElements.get('sham-recipe')) customElements.define('sham-recipe', ShamRecipe);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.ShamRecipeRules = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
